import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';

export const StyledInvalidSession = styled.section`
  .search-form {
    position: static;
    margin: ${toRem(32)} 0;
  }
`;
